import { ConnectorInterface } from '@interface/connector/connector.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialConnectorsState: BaseStoreInterface<Record<string, ConnectorInterface>> = {
  ...BaseStoreStructure,
  data: {},
};
